import React, { useContext } from "react";
import trans from "../../../../../../utils";
import { Input, TextAreaInput } from "../../../../../Helpers/Input/Input";
import Dropfile from "../../../../../Helpers/Dropzone/Dropzone";
import { popupcontext } from "../../../../../../context/Popupscontext";
import Loader from "../../../../../Helpers/Loader/Loader";

export default function BuildingDetails({
	addPOI,
	uniqueId,
	selected,
	poiAttachments,
	Loading,
	select,
	clear,
}) {
	let { konvaMode, isEditing } = useContext(popupcontext);
	console.log("poiAttachments", poiAttachments);
	console.log("LOADING........", Loading);
	return (
		<div style={{ paddingInline: "8px" }}>
			<div style={{ fontWeight: "600", fontSize: "16px" }}>
				{trans("Building Details")}
			</div>
			<div
				style={{
					maxHeight: !uniqueId ? "calc(100vh - 415px)" : "calc(100vh - 270px)",
					overflowY: "auto",
					overflowX: "hidden",
					backgroundColor: "#d9d9d920",
				}}
			>
				<>
					<Input
						title={trans("Building Name")}
						type="text"
						placeholder={trans("Enter building name")}
						id="name"
						name="name"
						formstyle="mt-3 mb-2"
						onBlur={(e) => addPOI.handleBlur(e)}
						onChange={(e) => addPOI.handleChange(e)}
						errors={addPOI.errors.name}
						touched={addPOI.touched.name}
						value={addPOI.values.name || ""}
						disabled={konvaMode}
					/>
					<Input
						title={trans("Building Code")}
						type="text"
						placeholder={trans("Enter building code")}
						id="code"
						name="code"
						onBlur={(e) => addPOI.handleBlur(e)}
						onChange={(e) => addPOI.handleChange(e)}
						errors={addPOI.errors.code}
						touched={addPOI.touched.code}
						value={addPOI.values.code || ""}
						disabled={konvaMode || (select && selected.polyid)}
					/>
					<TextAreaInput
						title={trans("Description")}
						placeholder={trans("Enter building description")}
						id="notes"
						name="notes"
						formstyle="my-2"
						onBlur={(e) => addPOI.handleBlur(e)}
						onChange={(e) => addPOI.handleChange(e)}
						touched={addPOI.touched.notes}
						errors={addPOI.errors.notes}
						value={addPOI.values.notes || ""}
						disabled={konvaMode}
					/>
					<Dropfile
						name="attachments"
						addData={addPOI}
						disabled={konvaMode}
						projectSetupSteps={select}
						EditableAttachments={poiAttachments}
						clear={clear}
					/>{" "}
				</>
			</div>
		</div>
	);
}
